<div class="government-hero-section">
	<!-- Digital Core -->
	<digital-core></digital-core>

	<!-- Government Hero -->
	<government-hero></government-hero>
</div>
<!-- Continuous Compliance -->
<continuous-compliance></continuous-compliance>

<!-- Ready Set -->
<ready-set></ready-set>
